import React from "react";
import Check from "./assets/icons/check.png";
// import Star from "./assets/icons/star.png";
// import HalfStar from "./assets/icons/halfStar.png";
import Stethoscope from "./assets/icons/stethoscope.png";
import Shield from "./assets/icons/shield.png";
import Ring from "./assets/icons/ring.png";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const Packages = () => {
  const packagePlan = [
    {
      id: 1,
      title: "Bonus Package",
      price: 55000,
      properties: [
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Complete blood count",
        "Thyroid function",
      ],
    },
    {
      id: 2,
      title: "Silver Package",
      price: 70000,
      properties: [
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Thyroid function",
        "Liver Function",
      ],
    },
    {
      id: 3,
      title: "Male Gold Package",
      price: 100000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Prostate",
      ],
    },
    {
      id: 4,
      title: "Female Gold Package",
      price: 100000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Pap Smear",
        "Stool",
        "Liver Function",
      ],
    },
    {
      id: 5,
      title: "Male Diamond Package",
      price: 130000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Pap Smear",
        "Stool",
        "Liver Function",
        "Hiv Screening",
        "Prostate",
      ],
    },
    {
      id: 6,
      title: "Female Diamond Package",
      price: 130000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Pap Smear",
        "Stool",
        "Liver Function",
        "Hiv Screening",
        "Thyroid Screening",
        "Full Light",
        "Urea",
      ],
    },
    {
      id: 7,
      title: "Male Platinum Package",
      price: 160000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Pap Smear",
        "Stool",
        "Liver Function",
        "Hiv Screening",
        "Erythrocyte",
      ],
    },
    {
      id: 8,
      title: "Female Platinum Package",
      price: 160000,
      properties: [
        "X-ray chest",
        "Hepatitis B&C",
        "Full blood count",
        "Blood Sugar",
        "Calcium",
        "Electrolyte",
        "Serum",
        "Low blood count",
        "Pap Smear",
        "Stool",
        "Liver Function",
        "Hiv Screening",
        "Thyroid Screening",
        "Full Light",
        "Urea",
        "Ultrasound abdomen",
        "Breast Scan",
      ],
    },
  ];
  return (
    <div className="bg-lightGrey">
      <div
        data-aos="fade-in"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="flex flex-col items-center gap-4  lg:px-24 md:px-10 px-4 py-10"
      >
        <h1 className="text-2xl font-semibold text-primaryPurple">
          Comprehensive Healthcare Packages
        </h1>
        <p className="text-gray-500 text-sm">
          Comprehensive Health Screening Programs for Your Wellbeing
        </p>
        <div className="flex items-center gap-3 text-center text-sm">
          <div className="flex items-center gap-2">
            <img src={Shield} className="w-[1.5rem]" alt="" />
            <p>Professional Diagnostics</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={Ring} alt="" />
            <p>Certified Lab Tets</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={Stethoscope} alt="" />
            <p>Expert Analysis</p>
          </div>
        </div>
      </div>

      <section className="flex  justify-center pb-5 ">
        <div className="grid grid-flow-row lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 place-items-start">
          {packagePlan.map((item) => (
            <div
              data-aos="fade-in"
              data-aos-delay="0"
              data-aos-duration="1000"
              key={item.id}
              className={`${
                item.title === "Bonus Package"
                  ? "border-gray-300 bg-gray-100"
                  : item.title === "Silver Package"
                  ? "border-purple-950/50"
                  : item.title === "Male Gold Package" ||
                    item.title === "Female Gold Package"
                  ? "bg-yellow/10 border-yellow"
                  : item.title === "Male Diamond Package" ||
                    item.title === "Female Diamond Package"
                  ? "bg-primaryPurple/10 border-primaryPurple"
                  : item.title === "Male Platinum Package" ||
                    item.title === "Female Platinum Package"
                  ? "bg-gradient-to-r from-yellow/20 to-primaryPurple/20 border-purple-950/50"
                  : ""
              } " border rounded-lg p-4 w-[22rem]`}
            >
              <h1 className="text-xl font-semibold text-primaryPurple">
                {item.title}
              </h1>
              <p className="text-2xl font-semibold text-primaryPurple">
                #{item.price}
                <span className="text-gray-400 text-sm font-normal">
                  /person
                </span>
              </p>
              <div className="flex flex-col gap-2 pb-10 pt-2">
                {item.properties.map((props) => (
                  <div className="items-center flex gap-2">
                    <img src={Check} className="w-[1rem] h-[1rem]" alt="" />
                    <p className="text-gray-600 text-sm">{props}</p>
                  </div>
                ))}
              </div>

              <button className="bg-primaryPurple rounded-md py-3 text-white w-full text-sm">
                Book Now
              </button>
            </div>
          ))}
        </div>
      </section>

      <div className="lg:px-24 md:px-10 px-4 py-10">
        <h1
          data-aos="zoom-in"
          data-aos-delay="0"
          data-aos-duration="500"
          className="text-primaryPurple font-semibold text-center text-2xl py-5 pb-9"
        >
          Why Choose Clear Icon
        </h1>

        <div className="flex md:flex-row flex-col items-center justify-center text-center gap-10">
          <div data-aos="fade-in" data-aos-delay="0" data-aos-duration="1000">
            <h1 className="font-semibold text-primaryPurple">
              Expert Diagnostics
            </h1>
            <p className="text-gray-500 mx-auto w-[70%] text-sm pt-2">
              State-of-the-art equipment and certified professionals
            </p>
          </div>
          <div data-aos="fade-in" data-aos-delay="0" data-aos-duration="1000">
            <h1 className="font-semibold text-primaryPurple">
              Quality Assurance
            </h1>
            <p className="text-gray-500 mx-auto w-[70%] text-sm pt-2">
              ISO 15189 accredited laboratory
            </p>
          </div>
          <div data-aos="fade-in" data-aos-delay="0" data-aos-duration="1000">
            <h1 className="font-semibold text-primaryPurple">Quick Results</h1>
            <p className="text-gray-500 mx-auto w-[70%] text-sm pt-2">
              Fast turnaround time for your reports
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packages;
